var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"batchReadings"}},[_c('PageTitle',{attrs:{"title":_vm.$t('batch_reading.d_title'),"subtitle":_vm.$t('batch_reading.d_subtitle')}}),_c('div',{staticClass:"container"},[_c('Datatable',{staticClass:"datatable",attrs:{"entity":_vm.entity,"parameters":_vm.parameters,"onRowClick":_vm.onRowClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }